export default __webpack_public_path__ + "static/media/kitchen4-afterF-480w.1e359fa5.png";